"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MonitorCheckUpdatedEvent = void 0;
const applicationEvent_1 = require("./applicationEvent");
class MonitorCheckUpdatedEvent extends applicationEvent_1.ApplicationEvent {
    constructor(monitorCheck) {
        super();
        this.monitorCheck = monitorCheck;
    }
    getMessageType() {
        return applicationEvent_1.ApplicationEventType.MONITOR_CHECK_UPDATED;
    }
    getExchangeName() {
        return applicationEvent_1.ApplicationEventExchangeName.MONITOR_CHECK_UPDATED;
    }
}
exports.MonitorCheckUpdatedEvent = MonitorCheckUpdatedEvent;
